import {atom, selector, DefaultValue} from "recoil"
import {recoilPersist} from "recoil-persist"
import {Story, Video} from "../types"

interface VideoState {
  current?: HTMLVideoElement | null
  muted?: boolean
}

const persist =
  typeof sessionStorage !== `undefined`
    ? recoilPersist({
        key: "recoil-persist",
        storage: sessionStorage,
      })
    : null

export const videoRefState = atom<VideoState>({
  key: "videoRef",
  default: {},
})

const videoMutedInternal = atom<boolean>({
  key: "videoMutedInternal",
  default: true,
  effects_UNSTABLE: persist?.persistAtom ? [persist.persistAtom] : undefined,
})

export const videoMutedState = selector<boolean>({
  key: "videoMuted",
  get: ({get}) => get(videoMutedInternal),
  set: ({get, set}, newValue: boolean | DefaultValue) => {
    const muted = newValue instanceof DefaultValue ? true : newValue
    const {current} = get(videoRefState)
    if (current) current.muted = muted
    set(videoMutedInternal, muted)
  },
})

export const videoPausedState = atom<boolean>({
  key: "videoPaused",
  default: false,
})

export const videoTimeState = atom<number>({
  key: "videoTime",
  default: 0,
})

export const currentVideoState = atom<Video | null>({
  key: "currentVideo",
  default: null,
})

export const currentStoryState = atom<Story | null>({
  key: "currentStory",
  default: null,
})

export const homepageWatchedState = atom<boolean>({
  key: "watchedHomepage",
  default: false,
})

export const watchedStoriesState = atom<Story[]>({
  key: "watchedStories",
  default: [],
  effects_UNSTABLE: persist?.persistAtom ? [persist.persistAtom] : undefined,
})

export const subtitlesState = atom<string[] | undefined>({
  key: "subtitles",
  default: undefined,
})

// Reset watched stories state when the browser is
// refreshed or closed explicitly
// NOTE: video muted state is also persisted!
if (typeof window !== `undefined`) {
  window.onunload = window.onbeforeunload = function () {
    sessionStorage.clear()
  }
}
